import React, { Suspense } from 'react';
import { connect } from 'react-redux';
import componentLoader from 'utils/componentLoader';
import { BrowserRouter as Router, Route, Routes } from 'utils/router';
import { setFilterDivisions } from 'modules/globalFilters';
import { getAuthCurrentUserSelector, getCurrentUser } from 'modules/auth';
import { env_bayer, PUBLIC_URL } from 'env';
import Loader from 'components/common/Loader';
import routesAdvisor from './routesAdvisor';
import RoutesWrapper from './RoutesWrapper';

const Login = componentLoader(
  () =>
    import(/* webpackChunkName: "common-Login" */ 'components/common/Login/')
);
const BayerLogin = componentLoader(
  () =>
    import(
      /* webpackChunkName: "common-BayerLogin" */ 'components/common/BayerLogin/'
    )
);
const AuthView = componentLoader(
  /* webpackChunkName: "routes-AuthView" */ () => import('./AuthView')
);
const AuthAdvisorView = componentLoader(
  /* webpackChunkName: "routes-AuthAdvisorView" */ () =>
    import('./AuthAdvisorView')
);
const AuthCustomersView = componentLoader(
  /* webpackChunkName: "routes-AuthCustomersView" */ () =>
    import('./AuthCustomersView')
);
const CustomerView = componentLoader(
  /* webpackChunkName: "routes-CustomerView" */ () => import('./CustomerView')
);

const RoutesContainer = (appProps) => (
  <Suspense fallback={<Loader />}>
    <Router basename={PUBLIC_URL || undefined}>
      <div className="page">
        <Routes>
          <Route
            path="/login/*"
            element={
              // Bayer QuantumTerra
              env_bayer === 'true' ? <BayerLogin /> : <Login />
            }
          />
          <Route
            path="/advisor/*"
            element={
              <AuthAdvisorView
                component={() => (
                  <RoutesWrapper {...appProps} menu={routesAdvisor} />
                )}
                {...appProps}
              />
            }
          />
          <Route
            path="/customer/:customerId/*"
            element={
              <AuthCustomersView
                component={() => <CustomerView {...appProps} />}
                {...appProps}
              />
            }
          />
          <Route path="*" element={<AuthView {...appProps} />} />
        </Routes>
      </div>
    </Router>
  </Suspense>
);

const routesContainer = connect(
  (state) => ({
    currentUser: getAuthCurrentUserSelector(state),
  }),
  (dispatch) => ({
    setFilterDivisions: () => dispatch(setFilterDivisions()),
    getCurrentUser: (id) => dispatch(getCurrentUser(id)),
    dispatch,
  })
)(RoutesContainer);

export default routesContainer;
